// modules
import { listen } from 'weblite-router'
import { SESSION_STORAGE_KEYS } from '$logic/client-device/types'
import { handleLocationSearch, setGAPage } from './helper'
import {
  sessionStorageGetItem,
  sessionStorageSetItem,
} from '$func/session-storage'

export function initiateRouterListener() {
  // NOTE: After the history has been initiated, the next line codes should be executed.
  const refreshCount =
    sessionStorageGetItem(SESSION_STORAGE_KEYS.REFRESH_COUNT) || 0
  handleLocationSearch(window.location.search)
  sessionStorageSetItem(SESSION_STORAGE_KEYS.REFRESH_COUNT, refreshCount + 1)

  listen(() => {
    setGAPage()
  })
}
